import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from 'Components/ComboBox'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import MessageBox from '../MessageBox'
import {
  ModernDialogActions,
  ModernDialogContent,
  primaryActionSx,
  QuestionBlock,
  questionnaireDialogSx,
  questionnairePaperSx,
  QuestionnaireTitle,
} from '../QuestionnaireDialogFrame'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
export default function QuestionAnswerFormProduit({ updateReports, setOpenFiKnowledge }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [questionanswer, setQuestionanswer] = useState([])

  const [open, setOpen] = useState(true)
  const [score, setScore] = useState(null)

  const { handleSubmit, reset, setValue } = useForm({})

  useEffect(() => {
    fetchQuestionanswer()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ans: [],
    }
    Object.keys(data).forEach((v, e) => {
      payload.ans.push(parseInt(data[v].id))
    })

    const response = await makePostRequest(urls.ProduitFiKnowledgeQuestionary, payload, {}, true)
    if (response.status === 200) {
      let res_data = response.data
      updateReports()
      setScore(res_data.score)
      setOpen(false)
      handleClose()
    }
  }

  const fetchQuestionanswer = async () => {
    const url = urls.ProduitFiKnowledgeQuestionary
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setQuestionanswer(data)
    }
  }
  const SelectBox = ({ val, namev }) => {
    const [selectedVal, setSelectedVal] = useState(null)
    useEffect(() => {
      let sf = val.ans.filter((v) => v.selected === 1)

      if (sf.length > 0) {
        setValue(namev, sf[0])
        setSelectedVal(sf[0])
      }
    }, [])

    return (
      <>
        <ComboBox
          handleAutoComplete={(e, j) => {
            setValue(namev, j)
            setSelectedVal(j)
          }}
          data={val.ans}
          name={namev}
          required={true}
          selectedValue={selectedVal}
          sx={{ width: '100%', mt: 1 }}
        />
      </>
    )
  }
  const totalQuestions = questionanswer?.length || 0

  return (
    <>
      {(score === 0 || score > 0) && (
        <MessageBox value={score} page={'Produit'} setOpenFiKnowledge={setOpenFiKnowledge} />
      )}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={open}
        className="no-drag"
        PaperProps={{ sx: questionnairePaperSx }}
        sx={questionnaireDialogSx}
      >
        <QuestionnaireTitle
          eyebrow={t('monPatrimoine.stepOfTotal', { step: 2, total: 4 })}
          title={t('monPatrimoine.fiKnowledgeProduitTitle')}
          subtitle={t('monPatrimoine.fiKnowledgeProduitSubtitle')}
          step={2}
          total={4}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModernDialogContent>
            {questionanswer &&
              questionanswer.map((val, idx) => (
                <QuestionBlock key={idx} index={idx} total={totalQuestions} question={val.question}>
                  <SelectBox namev={'qv' + idx} val={val} />
                </QuestionBlock>
              ))}
          </ModernDialogContent>
          <ModernDialogActions>
            <Button variant="contained" type="submit" sx={primaryActionSx}>{t('monPatrimoine.validate')}</Button>
            {/* <Button onClick={handleClose}>Annuler</Button> */}
          </ModernDialogActions>
        </form>
      </Dialog>
    </>
  )
}
